
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forex/buy-forex",
      function () {
        return require("private-next-pages/forex/buy-forex.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forex/buy-forex"])
      });
    }
  